import { Controller } from "stimulus";
import data from '@emoji-mart/data';
import { Picker } from 'emoji-mart';
import customEmojiData from "../new-custom-emoji-list.json"


export default class extends Controller {
  
  static targets = ["emojiPickerContainer", "commentInput"];

  
  connect() {
    

    var i18n = {
      "search": "Cerca un'emoji...",
      "search_no_results_1": "Nessuna emoji",
      "search_no_results_2": "Impossibile trovare l'emoji",
      "pick": "Scegli un'emoji…",
      "add_custom": "Aggiungi emoji personalizzata",
      "categories": {
        "activity": "Attività",
        "custom": "Personalizzate",
        "flags": "Bandiere",
        "foods": "Cibi e bevande",
        "frequent": "Usate di frequente",
        "nature": "Animali e natura",
        "objects": "Oggetti",
        "people": "Faccine e persone",
        "places": "Viaggi e luoghi",
        "search": "Risultati della ricerca",
        "symbols": "Simboli"
      },
      "skins": {
        "choose": "Scegli tono della pelle predefinito",
        "1": "Predefinito",
        "2": "Chiaro",
        "3": "Medio-chiaro",
        "4": "Medio",
        "5": "Medio-scuro",
        "6": "Scuro"
      }
    }

    var picker = new Picker({ data: data, custom: customEmojiData, i18n: i18n, previewPosition: "none", skinTonePosition: "none", categories: ["frequent", "people", "hathor", "nature", "foods", "activity", "places", "objects", "symbols", "flags"], set: "native", icons: "outline", theme: "light", categoryIcons: { "hathor": { src: "/assets/emoji/custom/90x90/emoji0.png" } }, onEmojiSelect: (e) => { this.selectEmoji(e, this) }})


    this.emojiPickerContainerTarget.appendChild(picker);

    document.addEventListener("click", (e) => {
      if (!e.target.closest(".emoji-picker-container")) {
        this.emojiPickerContainerTarget.classList.add("hidden");
      }
    });


  }


  close(e, _context) {
    var that = _context;
    setTimeout(() => {
        if (that.emojiPickerContainerTarget.classList.contains("hidden") == false) {
    
        that.emojiPickerContainerTarget.classList.add("hidden");
        }
      }, 0);
  }


  toggle() {
    if (this.hasEmojiPickerContainerTarget) {
      this.emojiPickerContainerTarget.classList.toggle("hidden");
    }
  }

  selectEmoji(e, _context) {
    
      var that = _context;

      var emoji = e.native == undefined ? e.shortcodes : e.native;

      that.insertAtCursor(that.commentInputTarget, emoji);
      var event = new Event('change');
      this.commentInputTarget.dispatchEvent(event);
  }



  insertAtCursor(myField, myValue) {
    
    if (document.selection) {
        myField.focus();
        const sel = document.selection.createRange();
        sel.text = myValue;
    }
    
    else if (myField.selectionStart || myField.selectionStart == '0') {
        var startPos = myField.selectionStart;
        var endPos = myField.selectionEnd;
        myField.value = myField.value.substring(0, startPos)
            + myValue
            + myField.value.substring(endPos, myField.value.length);

        myField.selectionStart = startPos + myValue.length; myField.selectionEnd = startPos + myValue.length;

    } else {
        myField.value += myValue;
    }
}

}

